// StatBox.js
import React, { useEffect, useState } from 'react';
import Odometer from 'react-odometerjs';
import PropTypes from "prop-types";

import "./StatBox.css";

const StatBox = ({ label, value, loading, numberStyles }) => {
  const [localValue, setLocalValue] = useState(0);

  useEffect(() => {
    if (loading) return; // Don't animate when loading
    if (localValue === 0) {
      setLocalValue(value);
    } else {
      const timeoutId = setTimeout(() => setLocalValue(value), 200);
      return () => clearTimeout(timeoutId);
    }
  }, [value, loading]);

  return (
    <div style={{ textAlign: "center" }}>
      <div style={{ fontSize: "0.9rem", fontWeight: "bold" }}>{label}</div>
      {loading ? (
        <div className="shimmer" />
      ) : (
        <div className="d-flex justify-content-center align-items-center" 
          style={{ height: "3.85rem" }}
        >
          <Odometer
            value={localValue}
            format="(,ddd).dd"
            duration={2000}
            style={{ fontSize: "3rem", fontWeight: "bold", ...numberStyles }}
          />
        </div>
      )}
    </div>
  );
};

StatBox.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.number.isRequired,
  loading: PropTypes.bool,
};

StatBox.defaultProps = {
  loading: false,
};

export default StatBox;


